import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { api, apiError, fileUrl } from "@/lib/api";
import { inputCls } from "@/pages/admin/ui";

export function VImageUpload({ value, onChange, label = "Image", testId = "vimage" }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const body = new FormData();
    body.append("file", file);
    try {
      const { data } = await api.post("/vendor/upload", body, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image téléversée");
    } catch (error) {
      toast.error(apiError(error, "Upload impossible"));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <span className="mb-1.5 block text-[11px] font-bold uppercase tracking-wide text-slate-500">{label}</span>
      <div className="flex items-start gap-3">
        <div className="relative flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-line bg-slate-50">
          {value ? (
            <>
              <img src={fileUrl(value)} alt="" className="h-full w-full object-contain p-1.5" />
              <button type="button" data-testid={`${testId}-clear`} onClick={() => onChange("")}
                className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-white/90 text-slate-500 shadow">
                <X className="h-3.5 w-3.5" />
              </button>
            </>
          ) : <ImagePlus className="h-6 w-6 text-slate-300" />}
        </div>
        <div className="flex-1 space-y-2">
          <input data-testid={`${testId}-url`} value={value || ""} onChange={(e) => onChange(e.target.value)}
            placeholder="https://... ou téléversez un fichier" className={inputCls} />
          <input ref={inputRef} type="file" accept="image/*" data-testid={`${testId}-file`}
            onChange={(e) => upload(e.target.files?.[0])} className="hidden" />
          <button type="button" data-testid={`${testId}-btn`} onClick={() => inputRef.current?.click()} disabled={uploading}
            className="flex items-center gap-2 rounded-lg border border-line px-3 py-2 text-xs font-bold text-ink transition-colors duration-200 hover:border-brand hover:text-brand disabled:opacity-60">
            {uploading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImagePlus className="h-3.5 w-3.5" />}
            {uploading ? "Téléversement..." : "Téléverser une image"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VImageUpload;
